<template>
  <div class="card">
    <div class="card-body">
      <div>
        <a-switch
          default-checked
          class="m-2"
          style="margin-bottom: 20px; float: right"
          :checked-children="$t('utilisateur.active')"
          :un-checked-children="$t('utilisateur.nonActive')"
          @change="onChange"
        />
        <a-button
          type="file-pdf"
          @click="generatePdf"
          style="margin-bottom: 20px; float: right"
        >
          <a-icon type="file-pdf" @click="generatePdf" />
          {{ $t("action.imprimerTab") }}
        </a-button>

        <a-button
          type="file-pdf"
          @click="generatePdfLogins"
          :loading="loadingLogins"
          style="margin-bottom: 20px; margin-right: 20px; float: right"
        >
          <a-icon type="file-pdf" />
          {{ $t("liste.imprimerLoginsEnsg") }}
        </a-button>

        <a-button type="user-add" @click="showModal">
          <a-icon type="user-add" @click="showModal" />
          {{ $t("liste.ajouterEnseignant") }}
        </a-button>

        <div>
          <a-modal
            :visible="visibleData"
            @cancel="handleCancel"
            :width="980"
            :title="$t('all.enterInformationBelow')"
            :footer="false"
          >
            <a-form :form="form" class="container" @submit="addEnseignant">
              <fieldset>
                <legend>{{ $t("personnel.infoBase") }}:</legend>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.nom')">
                      <a-input
                        :placeholder="$t('profil.nom')"
                        v-decorator="[
                          'lastName',
                          {
                            rules: [
                              {
                                required: true,
                                message: $t('requis.nom'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.prenom')">
                      <a-input
                        :placeholder="$t('profil.prenom')"
                        v-decorator="[
                          'firstName',
                          {
                            rules: [
                              {
                                required: true,
                                message: $t('requis.prenomPere'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.middleName')">
                      <a-input
                        :placeholder="$t('profil.middleName')"
                        v-decorator="['middleName']"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.dateNaissance')">
                      <a-date-picker
                        v-decorator="['birthDate']"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="isKenyan ? $t('personnel.idCard') : $t('personnel.cin')">
                      <a-input
                        :placeholder="isKenyan ? $t('personnel.idCard') : $t('personnel.cin')"
                        type="string"
                        v-decorator="[
                          'cin',
                          {
                            rules: isKenyan ? [] : [
                              {
                                pattern: /^[0-1][0-9]{7}$/,
                                message: $t('requis.cin01'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.adresse')">
                      <a-input
                        :placeholder="$t('profil.adresse')"
                        v-decorator="['adress']"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('liste.telephone')">
                      <phone-number-input
                        :default-country-code="isKenyan ? 'KE' : 'TN'"
                        v-decorator="[
                          'phone',
                          {
                            rules: [
                              {
                                required: true,
                                message: $t('requis.phoneRequired'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4" v-if="!isKenyan">
                    <a-form-item :label="$t('personnel.etatCivil')">
                      <a-input
                        :placeholder="$t('personnel.etatCivil')"
                        v-decorator="['civilStatus']"
                      />
                    </a-form-item>
                  </div>

                  <div class="col-md-4">
                    <a-form-item :label="$t('enseignant.needValidation')">
                      <a-select v-decorator="['needValidation']">
                        <a-select-option value="false">{{
                          $t("all.oui")
                        }}</a-select-option>
                        <a-select-option value="true">{{
                          $t("all.non")
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('enseignant.needNewsValidation')">
                      <a-select v-decorator="['needNewsValidation', { initialValue: 'true' }]">
                        <a-select-option value="false">{{ $t("all.oui") }}</a-select-option>
                        <a-select-option value="true">{{ $t("all.non") }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('enseignant.teacherAddNews')">
                      <a-select v-decorator="['teacherAddNews', { initialValue: 'true' }]">
                        <a-select-option value="true">{{ $t("all.oui") }}</a-select-option>
                        <a-select-option value="false">{{ $t("all.non") }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ isKenyan ? $t("personnel.qualifications") : $t("personnel.niveau") }}:</legend>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="isKenyan ? $t('personnel.qualifications') : $t('personnel.niveau')">
                      <a-input
                        :placeholder="isKenyan ? $t('personnel.qualifications') : $t('personnel.niveau')"
                        v-decorator="['level']"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-8">
                    <a-form-item :label="$t('personnel.experiences')">
                      <a-input
                        :placeholder="$t('personnel.experiences')"
                        type="textarea"
                        v-decorator="[
                          'experiences',
                          {
                            rules: [
                              {
                                required: false,
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("enseignant.detailPedagogiques") }}:</legend>

                <div class="row">
                  <div class="col-md-8">
                    <a-form-item
                      :label="$t('scolarite.affectationDansClasses') + ' :'"
                    >
                      <a-select
                        mode="multiple"
                        v-decorator="[
                          'classrooms',
                          {
                            rules: [
                              {
                                required: false,
                              },
                            ],
                          },
                        ]"
                        show-search
                        :allowClear="true"
                        :getPopupContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                        :placeholder="$t('paiement.listeClasses')"
                        style="width: 100%"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                      >
                        <a-select-option
                          v-for="classe in classesData"
                          :key="classe._id"
                          :value="classe._id"
                          >{{ classe.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="$t('emploi.matiere') + ' :'">
                      <a-select
                        mode="multiple"
                        v-decorator="[
                          'subjects',
                          {
                            rules: [
                              {
                                required: true,
                                message: $t('requis.matiere'),
                              },
                            ],
                          },
                        ]"
                        show-search
                        :allowClear="true"
                        :getPopupContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                        :placeholder="$t('scolarite.listeMatieres')"
                        style="width: 100%"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                      >
                        <a-select-option
                          v-for="subject in subjectsList"
                          :key="subject._id"
                          :value="subject._id"
                          >{{ subject.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('enseignant.specialite')">
                      <a-input
                        :placeholder="$t('enseignant.specialite')"
                        v-decorator="['speciality']"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('enseignant.grade')">
                      <a-input
                        :placeholder="$t('enseignant.grade')"
                        type="number"
                        v-decorator="[
                          'grade',
                          {
                            initialValue: '0',
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("personnel.infoContrat") }}:</legend>
                <div class="row">
                  <!-- <div class="col-md-4">
                    <a-form-item :label="$t('personnel.qualification')">
                      <a-select
                        v-decorator="['position']"
                        show-search
                        :allowClear="true"
                        :placeholder="$t('personnel.qualification')"
                        style="width: 100%"
                        option-filter-prop="children"
                      >
                        <a-select-option
                          v-for="position in positionsList"
                          :key="position._id"
                          :value="position._id"
                        >
                          {{ position.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>-->
                  <div class="col-md-6">
                    <a-form-item :label="$t('personnel.typeContrat')">
                      <a-input
                        :placeholder="$t('personnel.typeContrat')"
                        v-decorator="['contract']"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-6">
                    <a-form-item :label="$t('personnel.salaire') + ' (net)'">
                      <a-input
                        :placeholder="$t('personnel.salaire') + ' (net)'"
                        type="number"
                        v-decorator="['salary.net']"
                      />
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.dateEntretien')">
                      <a-date-picker
                        v-decorator="['interviewDate']"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('all.startDate')">
                      <a-date-picker
                        v-decorator="['StartDate']"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('all.endDate')">
                      <a-date-picker
                        v-decorator="['endDate']"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("enseignant.compte") }}</legend>
                <div class="row">
                  <div class="col-md-6">
                    <a-form-item :label="$t('enseignant.usernameEmail')">
                      <a-input
                        :placeholder="$t('enseignant.usernameEmail')"
                        v-decorator="[
                          'email',
                          {
                            rules: [
                              {
                                message: $t('requis.usernameEmail'),
                                required: true,
                              },
                              {
                                validator: validateNoWhitespace,
                                message: $t('requis.noWhitespace'),
                              },
                              {
                                validator: validateUsernameAvailable,
                                message: $t('error.usernameExists'),
                              },
                            ],
                          },
                        ]"
                      >
                        <a-icon
                          slot="prefix"
                          type="user"
                          style="color: rgba(0, 0, 0, 0.25)"
                        />
                      </a-input>
                    </a-form-item>
                  </div>
                  <div class="col-md-6">
                    <a-form-item
                      :label="$t('profil.mdp')"
                      :validate-status="passwordError() ? 'error' : ''"
                      :help="passwordError() || ''"
                    >
                      <a-input-password
                        :placeholder="$t('profil.mdp')"
                        v-decorator="[
                          'password',
                          {
                            initialValue: generatedPassword,
                            rules: [
                              {
                                validator: validateStrongPassword,
                              },
                            ],
                          },
                        ]"
                      >
                        <a-icon
                          slot="prefix"
                          type="lock"
                          style="color: rgba(0, 0, 0, 0.25)"
                        />
                      </a-input-password>
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("personnel.detailPaiement") }}:</legend>
                <div class="row">
                  <div class="col-md-3" v-if="!isKenyan">
                    <a-form-item :label="$t('personnel.tauxHoraire')">
                      <a-input
                        :placeholder="$t('personnel.tauxHoraire')"
                        type="number"
                        v-decorator="[
                          'hourlyRate',
                          {
                            initialValue: 0,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3">
                    <a-form-item :label="$t('personnel.jourSemaine')">
                      <a-input
                        :placeholder="$t('personnel.jourSemaine')"
                        type="number"
                        v-decorator="[
                          'dayOfWeek',
                          {
                            initialValue: 0,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3">
                    <a-form-item :label="isKenyan ? $t('personnel.sha') : $t('personnel.cnss')">
                      <a-input
                        :placeholder="isKenyan ? $t('personnel.sha') : $t('personnel.cnss')"
                        v-decorator="[isKenyan ? 'SHA' : 'CNSS', { initialValue: isKenyan ? '' : 0 }]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3" v-if="isKenyan">
                    <a-form-item :label="$t('personnel.nssf')">
                      <a-input
                        :placeholder="$t('personnel.nssf')"
                        v-decorator="['NSSF', { initialValue: '' }]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3" v-if="isKenyan">
                    <a-form-item :label="$t('personnel.pin')">
                      <a-input
                        :placeholder="$t('personnel.pin')"
                        v-decorator="['PIN', { initialValue: '' }]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3" v-if="!isKenyan">
                    <a-form-item :label="$t('personnel.rib')">
                      <a-input
                        :placeholder="$t('personnel.rib')"
                        v-decorator="['RIB', { initialValue: '0' }]"
                      />
                    </a-form-item>
                  </div>
                </div>
                <div class="row" v-if="isKenyan">
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.bankAccountNo')">
                      <a-input
                        :placeholder="$t('personnel.bankAccountNo')"
                        v-decorator="['bankAccountNo', { initialValue: '0' }]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.bankName')">
                      <a-select
                        v-decorator="['bankName']"
                        :placeholder="$t('personnel.bankName')"
                        show-search
                        :allowClear="true"
                        style="width: 100%"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        :getPopupContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      >
                        <a-select-option
                          v-for="bank in kenyanBanks"
                          :key="bank"
                          :value="bank"
                          >{{ bank }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.bankBranch')">
                      <a-input
                        :placeholder="$t('personnel.bankBranch')"
                        v-decorator="[
                          'bankBranch',
                          {
                            initialValue: '',
                            rules: [
                              {
                                pattern: /^[A-Za-z\s-]*$/,
                                message: $t('requis.alphabeticOnly'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("personnel.attendanceConfig") }}:</legend>
                <div class="row">
                  <div class="col-md-6">
                    <a-form-item :label="$t('personnel.expectedHoursPerDay')">
                      <a-input
                        type="number"
                        step="0.5"
                        :placeholder="$t('personnel.expectedHoursPerDay')"
                        v-decorator="['expectedHoursPerDay', { initialValue: null }]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-6">
                    <a-form-item :label="$t('personnel.daysOff')">
                      <a-select
                        mode="multiple"
                        style="width: 100%"
                        :placeholder="$t('personnel.daysOffPlaceholder')"
                        v-decorator="['daysOff', { initialValue: [] }]"
                      >
                        <a-select-option :value="0">{{ $t("personnel.weekday_0") }}</a-select-option>
                        <a-select-option :value="1">{{ $t("personnel.weekday_1") }}</a-select-option>
                        <a-select-option :value="2">{{ $t("personnel.weekday_2") }}</a-select-option>
                        <a-select-option :value="3">{{ $t("personnel.weekday_3") }}</a-select-option>
                        <a-select-option :value="4">{{ $t("personnel.weekday_4") }}</a-select-option>
                        <a-select-option :value="5">{{ $t("personnel.weekday_5") }}</a-select-option>
                        <a-select-option :value="6">{{ $t("personnel.weekday_6") }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <a-form-item :label="$t('personnel.expectedTeachingHours')">
                      <div
                        v-for="(row, index) in expectedTeachingRows"
                        :key="'create-teach-' + index"
                        class="row mb-2"
                        style="align-items: center"
                      >
                        <div class="col-md-6">
                          <a-select
                            show-search
                            allow-clear
                            style="width: 100%"
                            option-filter-prop="children"
                            :placeholder="$t('emploi.matiere')"
                            v-model="row.subject"
                            @change="(val) => onExpectedSubjectChange(row, val)"
                          >
                            <a-select-option
                              v-for="subject in subjectsList"
                              :key="subject._id"
                              :value="subject._id"
                            >
                              {{ subject.name }}
                            </a-select-option>
                          </a-select>
                        </div>
                        <div class="col-md-4">
                          <a-input-number
                            style="width: 100%"
                            :min="0"
                            :step="0.5"
                            :placeholder="$t('personnel.hoursPerWeek')"
                            v-model="row.hoursPerWeek"
                          />
                        </div>
                        <div class="col-md-2">
                          <a-button
                            type="danger"
                            icon="delete"
                            @click="removeExpectedTeachingRow(index)"
                          />
                        </div>
                      </div>
                      <a-button type="dashed" block icon="plus" @click="addExpectedTeachingRow">
                        {{ $t("personnel.addSubjectHours") }}
                      </a-button>
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("personnel.autre") }}:</legend>
                <div class="row">
                  <a-form-item :label="$t('profil.notes')" class="col-md-12">
                    <a-input
                      :placeholder="$t('profil.notes')"
                      type="textarea"
                      v-decorator="['notes']"
                    />
                  </a-form-item>
                </div>
              </fieldset>
              <div class="form-actions mt-0 row">
                <div class="col-md-2 offset-md-8 p-0">
                  <a-button
                    key="back"
                    @click="handleCancel"
                    :disabled="loadingEnseignant"
                    >{{ $t("action.annuler") }}</a-button
                  >
                </div>
                <div class="col-md-2 p-0">
                  <a-button
                    type="primary"
                    htmlType="submit"
                    :disabled="loadingEnseignant"
                    :loading="loadingEnseignant"
                    >{{ $t("action.ajouter") }}</a-button
                  >
                </div>
              </div>
            </a-form>
          </a-modal>

          <!-- UPDATE MODAL --->
          <a-modal
            v-model="visibleUpdateData"
            @cancel="handleCancel"
            :width="640"
            :title="$t('all.enterInformationBelow')"
            :footer="false"
            :key="updateModelKey"
            class="teacher-update-modal"
          >
            <a-form
              :form="updateForm"
              class="teacher-update-form"
              @submit="updateEnseignant"
            >
              <fieldset class="update-fieldset">
                <legend class="update-legend">{{ $t("enseignant.detailPedagogiques") }}</legend>
                <div class="row">
                  <div class="col-md-12">
                    <a-form-item :label="$t('emploi.matiere')" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                      <a-select
                        mode="multiple"
                        v-decorator="[
                          'subjects',
                          {
                            initialValue: updateData.subs,
                            rules: [
                              {
                                required: true,
                                message: $t('requis.matiere'),
                              },
                            ],
                          },
                        ]"
                        show-search
                        :allowClear="true"
                        :placeholder="$t('scolarite.listeMatieres')"
                        style="width: 100%"
                        option-filter-prop="children"
                      >
                        <a-select-option
                          v-for="subject in subjectsList"
                          :key="subject._id"
                          :value="subject._id"
                          >{{ subject.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <a-form-item :label="$t('enseignant.specialite')" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                      <a-input
                        :placeholder="$t('enseignant.specialite')"
                        v-decorator="[
                          'speciality',
                          {
                            initialValue: updateData.speciality,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-6">
                    <a-form-item :label="$t('enseignant.grade')" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                      <a-input
                        :placeholder="$t('enseignant.grade')"
                        type="number"
                        v-decorator="[
                          'grade',
                          {
                            initialValue: updateData.grade,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset class="update-fieldset">
                <legend class="update-legend">{{ $t("personnel.attendanceConfig") }}</legend>
                <div class="row">
                  <div class="col-md-6">
                    <a-form-item :label="$t('personnel.expectedHoursPerDay')" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
                      <a-input
                        type="number"
                        step="0.5"
                        v-decorator="[
                          'expectedHoursPerDay',
                          {
                            initialValue:
                              updateData.employee &&
                              updateData.employee.expectedHoursPerDay,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-6">
                    <a-form-item :label="$t('personnel.daysOff')" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
                      <a-select
                        mode="multiple"
                        style="width: 100%"
                        :placeholder="$t('personnel.daysOffPlaceholder')"
                        v-decorator="[
                          'daysOff',
                          {
                            initialValue:
                              (updateData.employee &&
                                updateData.employee.daysOff) ||
                              [],
                          },
                        ]"
                      >
                        <a-select-option :value="0">{{ $t("personnel.weekday_0") }}</a-select-option>
                        <a-select-option :value="1">{{ $t("personnel.weekday_1") }}</a-select-option>
                        <a-select-option :value="2">{{ $t("personnel.weekday_2") }}</a-select-option>
                        <a-select-option :value="3">{{ $t("personnel.weekday_3") }}</a-select-option>
                        <a-select-option :value="4">{{ $t("personnel.weekday_4") }}</a-select-option>
                        <a-select-option :value="5">{{ $t("personnel.weekday_5") }}</a-select-option>
                        <a-select-option :value="6">{{ $t("personnel.weekday_6") }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <a-form-item :label="$t('personnel.expectedTeachingHours')" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
                      <div
                        v-for="(row, index) in expectedTeachingRows"
                        :key="'update-teach-' + index"
                        class="row mb-2"
                        style="align-items: center"
                      >
                        <div class="col-md-6">
                          <a-select
                            show-search
                            allow-clear
                            style="width: 100%"
                            option-filter-prop="children"
                            :placeholder="$t('emploi.matiere')"
                            v-model="row.subject"
                            @change="(val) => onExpectedSubjectChange(row, val)"
                          >
                            <a-select-option
                              v-for="subject in subjectsList"
                              :key="subject._id"
                              :value="subject._id"
                            >
                              {{ subject.name }}
                            </a-select-option>
                          </a-select>
                        </div>
                        <div class="col-md-4">
                          <a-input-number
                            style="width: 100%"
                            :min="0"
                            :step="0.5"
                            :placeholder="$t('personnel.hoursPerWeek')"
                            v-model="row.hoursPerWeek"
                          />
                        </div>
                        <div class="col-md-2">
                          <a-button
                            type="danger"
                            icon="delete"
                            @click="removeExpectedTeachingRow(index)"
                          />
                        </div>
                      </div>
                      <a-button type="dashed" block icon="plus" @click="addExpectedTeachingRow">
                        {{ $t("personnel.addSubjectHours") }}
                      </a-button>
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset class="update-fieldset update-fieldset--validation">
                <legend class="update-legend">{{ $t("enseignant.permissionsValidation") }}</legend>
                <div class="row validation-toggles">
                  <div class="col-md-6">
                    <a-form-item :label="$t('enseignant.needValidation')" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }" class="validation-form-item">
                      <a-switch
                        :checked-children="$t('all.oui')"
                        :un-checked-children="$t('all.non')"
                        v-decorator="[
                          'needValidation',
                          {
                            valuePropName: 'checked',
                            initialValue: !updateData.needValidation,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-6">
                    <a-form-item :label="$t('enseignant.needNewsValidation')"  :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }" class="validation-form-item">

                      <a-switch

                        :checked-children="$t('all.oui')"
                        :un-checked-children="$t('all.non')"
                        v-decorator="[
                          'needNewsValidation',
                          {
                            valuePropName: 'checked',
                            initialValue: !(updateData.needNewsValidation),
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-6">
                    <a-form-item :label="$t('enseignant.teacherAddNews')" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }" class="validation-form-item">
                      <a-switch
                        :checked-children="$t('all.oui')"
                        :un-checked-children="$t('all.non')"
                        v-decorator="[
                          'teacherAddNews',
                          {
                            valuePropName: 'checked',
                            initialValue: updateData.teacherAddNews !== false,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <div class="form-actions update-form-actions">
                <a-button
                  key="back"
                  @click="handleCancel"
                  :disabled="loadingEnseignant"
                >
                  {{ $t("action.annuler") }}
                </a-button>
                <a-button
                  type="primary"
                  htmlType="submit"
                  :disabled="loadingEnseignant"
                  :loading="loadingEnseignant"
                >
                  <a-icon type="save" />
                  {{ $t("action.modifier") }}
                </a-button>
              </div>
            </a-form>
          </a-modal>

          <!-- Profile MODAL --->
          <a-drawer
            :title="$t('profil.profile')"
            placement="right"
            :closable="true"
            :visible="visibleProfileData"
            @close="handleCancel"
            :width="600"
          >
            <a-form class="container">
              <fieldset>
                <legend>{{ $t("personnel.infoBase") }}:</legend>
                <div class="row">
                  <div class="col-md-3">
                    <strong>{{ $t("enseignant.prenom") }}:</strong>
                    {{
                      updateData.employee ? updateData.employee.firstName : null
                    }}
                  </div>
                  <div class="col-md-3">
                    <strong>{{ $t("enseignant.nom") }}:</strong>
                    {{
                      updateData.employee ? updateData.employee.lastName : null
                    }}
                  </div>
                  <div class="col-md-3">
                    <strong>{{ $t("profil.middleName") }}:</strong>
                    {{
                      updateData.employee ? updateData.employee.middleName : null
                    }}
                  </div>
                  <div class="col-md-6">
                    <strong>{{ $t("enseignant.dateNaissance") }}:</strong>
                    {{
                      updateData.employee
                        ? moment(updateData.employee.birthDate).format(
                            "DD-MM-YYYY"
                          )
                        : null
                    }}
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-3">
                    <strong>{{ isKenyan ? $t('personnel.idCard') : $t("enseignant.cin") }}:</strong>
                    {{ updateData.employee ? updateData.employee.cin : null }}
                  </div>
                  <div class="col-md-3">
                    <strong>{{ $t("enseignant.adresse") }}:</strong>
                    {{
                      updateData.employee ? updateData.employee.adress : null
                    }}
                  </div>
                  <div class="col-md-6">
                    <strong>{{ $t("enseignant.telephone") }}:</strong>
                    {{ updateData.employee ? updateData.employee.phone : null }}
                  </div>
                </div>
                <div class="row mt-2" v-if="!isKenyan">
                  <div class="col">
                    <strong>{{ $t("enseignant.etatCivil") }}:</strong>
                    {{
                      updateData.employee
                        ? updateData.employee.civilStatus
                        : null
                    }}
                  </div>
                </div>
              </fieldset>
              <fieldset class="mt-4">
                <legend>{{ isKenyan ? $t("personnel.qualifications") : $t("personnel.niveau") }}:</legend>
                <div class="row">
                  <div class="col-md-4">
                    <strong>{{ isKenyan ? $t("personnel.qualifications") : $t("enseignant.niveau") }}:</strong>
                    {{ updateData.employee ? updateData.employee.level : null }}
                  </div>
                  <div class="col-md-8">
                    <strong>{{ $t("enseignant.experiences") }}:</strong>
                    {{
                      updateData.employee
                        ? updateData.employee.experiences
                        : null
                    }}
                  </div>
                </div>
              </fieldset>
              <fieldset v-if="profileDataLoading" class="mt-4">
                <legend>{{ $t("personnel.infoContrat") }}:</legend>
                <a-col :span="16" :offset="11">
                  <a-spin size="large" />
                </a-col>
              </fieldset>
              <fieldset v-else class="mt-4">
                <legend>{{ $t("personnel.infoContrat") }}:</legend>
                <div class="row">
                  <div class="col-md-4">
                    <strong>{{ $t("enseignant.qualifications") }}:</strong>
                    {{
                      updateData.employee && updateData.employee.position
                        ? updateData.employee.position.name
                        : null
                    }}
                  </div>
                  <div class="col-md-4">
                    <strong>{{ $t("enseignant.typeContrat") }}:</strong>
                    {{
                      updateData.employee ? updateData.employee.contract : null
                    }}
                  </div>
                  <div class="col-md-4">
                    <strong>{{ $t("enseignant.salaire") }}(net):</strong>
                    {{
                      updateData.employee &&
                      updateData.employee.salary &&
                      updateData.employee.salary.net
                        ? updateData.employee.salary.net
                        : null
                    }}
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-12">
                    <strong>{{ $t("etablissement.classes") }}:</strong>
                    <div
                      class="ml-4"
                      v-for="classroom in classroomAffectationProfile"
                      :key="classroom._id"
                    >
                      - {{ classroom.name }}
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <strong>{{ $t("enseignant.matiere") }}</strong>
                    <div
                      class="ml-4"
                      v-for="subject in updateData.subjects"
                      :key="subject._id"
                    >
                      - {{ subject.name }}
                    </div>
                  </div>
                  <div class="col-md-4">
                    <strong>{{ $t("enseignant.specialite") }}:</strong>
                    {{ updateData.speciality }}
                  </div>
                  <div class="col-md-4">
                    <strong>{{ $t("enseignant.grade") }}:</strong>
                    {{ updateData.grade }}
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-6">
                    <strong>{{ $t("enseignant.dateEntretien") }}:</strong>
                    {{
                      updateData.employee
                        ? moment(updateData.employee.interviewDate).format(
                            "DD-MM-YYYY"
                          )
                        : null
                    }}
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-6">
                    <strong>{{ $t("all.startDate") }}:</strong>
                    {{
                      updateData.employee
                        ? moment(updateData.employee.StartDate).format(
                            "DD-MM-YYYY"
                          )
                        : null
                    }}
                  </div>
                  <div class="col-md-6">
                    <strong>{{ $t("all.endDate") }}:</strong>
                    {{
                      updateData.employee
                        ? moment(updateData.employee.endDate).format(
                            "DD-MM-YYYY"
                          )
                        : null
                    }}
                  </div>
                </div>
              </fieldset>
              <fieldset class="mt-4">
                <legend>{{ $t("personnel.detailPaiement") }}:</legend>
                <div class="row">
                  <div class="col-md-6" v-if="!isKenyan">
                    <strong>{{ $t("enseignant.tauxHoraire") }}:</strong>
                    >{{
                      updateData.employee
                        ? updateData.employee.hourlyRate
                        : null
                    }}
                  </div>
                  <div class="col-md-6">
                    <strong>{{ $t("enseignant.jourSemaine") }}:</strong>
                    {{
                      updateData.employee ? updateData.employee.dayOfWeek : null
                    }}
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-6">
                    <strong>{{ isKenyan ? $t('personnel.sha') : $t('enseignant.cnss') }}:</strong>
                    {{ updateData.employee ? (isKenyan ? updateData.employee.SHA : updateData.employee.CNSS) : null }}
                  </div>
                  <div class="col-md-6" v-if="isKenyan">
                    <strong>{{ $t("personnel.nssf") }}:</strong>
                    {{ updateData.employee ? updateData.employee.NSSF : null }}
                  </div>
                </div>
                <div class="row mt-2" v-if="isKenyan">
                  <div class="col-md-6">
                    <strong>{{ $t("personnel.pin") }}:</strong>
                    {{ updateData.employee ? updateData.employee.PIN : null }}
                  </div>
                  <div class="col-md-6">
                    <strong>{{ $t('personnel.bankAccountNo') }}:</strong>
                    {{ updateData.employee ? updateData.employee.bankAccountNo : null }}
                  </div>
                </div>
                <div class="row mt-2" v-if="isKenyan">
                  <div class="col-md-6">
                    <strong>{{ $t('personnel.bankName') }}:</strong>
                    {{ updateData.employee ? updateData.employee.bankName : null }}
                  </div>
                  <div class="col-md-6">
                    <strong>{{ $t('personnel.bankBranch') }}:</strong>
                    {{ updateData.employee ? updateData.employee.bankBranch : null }}
                  </div>
                </div>
                <div class="row mt-2" v-if="!isKenyan">
                  <div class="col-md-6">
                    <strong>{{ $t("enseignant.rib") }}:</strong>
                    {{ updateData.employee ? updateData.employee.RIB : null }}
                  </div>
                </div>
              </fieldset>
              <fieldset class="mt-4">
                <legend>{{ $t("personnel.autre") }}:</legend>
                <div class="row">
                  <strong>{{ $t("enseignant.notes") }}:</strong>
                  {{ updateData.employee ? updateData.employee.notes : null }}
                </div>
              </fieldset>
            </a-form>
          </a-drawer>
        </div>
      </div>
      <div>
        <a-table
          :pagination="true"
          :data-source="filteredData"
          :loading="tableLoading"
          :columns="columns"
          @change="handleTableChange"
          :scrollToFirstRowOnChange="false"
          :customRow="
            (record) => {
              return {
                on: {
                  click: () => {
                    profile(record);
                  },
                },
              };
            }
          "
          rowKey="_id"
          :scroll="{ x: 'max-content' }"
        >
          <template slot="avatar" slot-scope="text, record">
            <a-avatar
              size="large"
              v-if="record.employee.photo"
              :src="
                settings.resourcesUrl.replace(
                  'FILE_PATH',
                  record.employee.photo
                )
              "
            />
            <a-avatar
              size="large"
              style="color: #f56a00; background-color: #fde3cf"
              v-else
              >{{ record.employee.firstName[0].toUpperCase() }}</a-avatar
            >
          </template>
          <template
            slot="middleName"
            slot-scope="text, record, index, column"
          >
            <span v-if="searchText && searchedColumn === column.dataIndex">
              <template
                v-for="(fragment, i) in String(text == null ? '' : text)
                  .split(
                    new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                  )"
              >
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                  >{{ fragment }}</mark
                >
                <template v-else>{{ fragment }}</template>
              </template>
            </span>
            <template v-else>{{ text || "" }}</template>
          </template>

          <template slot="StartDate" slot-scope="text, record">{{
            moment(record.StartDate).format("DD/MM/YYYY")
          }}</template>
          <template slot="endDate" slot-scope="text, record">
            {{
              record.endDate
                ? moment(record.endDate).format("DD/MM/YYYY")
                : $t("all.notSpecified")
            }}
          </template>
          <template slot="password" slot-scope="text, record">
            <a-button @click.stop="() => updatePasswordTrig(record)">
              <a-icon type="lock" />
              {{ $t("action.modifier") }}
            </a-button>
          </template>
          <template slot="operation" slot-scope="text, record">
            <a-button type="primary" @click.stop="() => edit(record)">
              <a-icon type="edit" />
              {{ $t("action.modifier") }}
            </a-button>
          </template>
          <div
            slot="filterDropdown"
            slot-scope="{
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }"
            style="padding: 8px"
          >
            <a-input
              v-ant-ref="(c) => (searchInput = c)"
              :placeholder="`${$t('personnel.chercher')} ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block"
              @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              "
              @pressEnter="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
              >{{ $t("paiement.chercher") }}</a-button
            >
            <a-button
              size="small"
              style="width: 90px"
              @click="() => handleReset(clearFilters)"
              >{{ $t("action.reinitialiser") }}</a-button
            >
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template
            slot="customRender"
            slot-scope="text, record, index, column"
          >
            <span v-if="searchText && searchedColumn === column.dataIndex">
              <template
                v-for="(fragment, i) in text
                  .toString()
                  .split(
                    new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                  )"
              >
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                  >{{ fragment }}</mark
                >
                <template v-else>{{ fragment }}</template>
              </template>
            </span>
            <template v-else>{{ text }}</template>
          </template>
          <template slot="subject" slot-scope="text, record">
            <div class="subject-tags">
              <a-tag
                v-for="subject in record.subjects.slice(0, 3)"
                :key="subject.id"
                color="blue"
              >
                {{ subject.name }}
              </a-tag>
            </div>
          </template>
          <template slot="delete" slot-scope="text, record">
            <a-popconfirm
              :title="$t('all.sureToDelete')"
              @confirm="() => onDelete(record.key)"
            >
              <a-button type="danger" @click.stop>
                <a-icon type="delete" href="javascript:;" />
                {{ $t("action.supprimer") }}
              </a-button>
            </a-popconfirm>
          </template>
        </a-table>
        <update-password
          :key="activeTeacherId"
          :visibleModalPassword="visibleModalPassword"
          :idTeacher="activeTeacherId"
          :firstName="activeTeacher.employee.firstName"
          :fetchToken="fetchToken"
          :lastName="activeTeacher.employee.lastName"
          :credentials="changePasswordProps"
          @updateCredentials="updateCredentials"
          :status="activeTeacher.status"
          :mfa="teacherMfa"
          @cancel="handleCancelPwd"
          @updateToken="updateToken"
          @mfa-disabled="onTeacherMfaDisabled"
          @reload="getTeachers"
          :token="teacherToken"
        />
      </div>
    </div>
    <vue-qr
      :text="qrDataBob"
      :logoSrc="getBuilding.logo"
      :callback="getQrImage"
      qid="teacher"
      class="hidden"
      style="z-index: -1000"
    ></vue-qr>

    <!-- Modal for QR code generation errors - Simple warning -->
    <a-modal
      v-model="visibleQrCodeErrorModal"
      :title="$t('liste.qrCodeErrorWarning')"
      :width="600"
      :footer="null"
    >
      <div>
        <a-alert
          :description="$t('liste.qrCodeErrorDescription')"
          type="warning"
          show-icon
          style="margin-bottom: 16px"
        />

        <div style="max-height: 300px; overflow-y: auto">
          <div
            v-for="user in qrCodeErrorData"
            :key="user._id"
            style="margin-bottom: 8px"
          >
            <strong>{{ user.fullName }}</strong>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
  <!--les conseillées pédagogiques-->
</template>

<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import "jspdf-autotable";
import { mapState } from "vuex";
import moment from "moment";
import updatePassword from "./updatePassword.vue";
import { generatePassword } from "@/utilities/settings";
import VueQr from "vue-qr";
const { generateAllLoginPdf } = require("@/utilities/pdfAllLogin");
import { pdfHeader } from "@/utilities/pdfUtils";
import { isKenyanSchool } from "@/utilities/countrySpecific";
import { showApiError } from "@/utilities/showApiError";

const TEACHER_ERROR_FIELDS = {
  TEACHER_INVALID_PHONE: "phone",
  TEACHER_INVALID_BIRTH_DATE: "birthDate",
  TEACHER_INVALID_CIN_CREATED_AT: "cinCreatedAt",
  TEACHER_INVALID_INTERVIEW_DATE: "interviewDate",
  TEACHER_INVALID_START_DATE: "StartDate",
  TEACHER_INVALID_END_DATE: "endDate",
  TEACHER_INVALID_BANK_BRANCH: "bankBranch",
  TEACHER_INVALID_EXPECTED_HOURS: "expectedHoursPerDay",
  TEACHER_CIN_DUPLICATE: "cin",
};
const TEACHER_DATE_FIELDS = [
  "birthDate",
  "cinCreatedAt",
  "interviewDate",
  "StartDate",
  "endDate",
];
import { KENYAN_BANKS } from "@/config/KenyanBanks";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  components: {
    updatePassword,
    VueQr,
  },
  computed: {
    ...mapState(["settings", "user"]),
    isKenyan() {
      return isKenyanSchool();
    },
    getBuilding() {
      return (
        this.settings.image.filter(
          (img) => img.db == this.settings.activeBuilding
        )[0] || {}
      );
    },
    qrDataBob() {
      return window.btoa(this.qrData + "#" + this.settings.base_url);
    },
    columns() {
      return [
        {
          title: this.$t("enseignant.photo"),
          dataIndex: "employee.photo",
          key: "avatar",
          width: "auto",
          scopedSlots: {
            customRender: "avatar",
          },
        },
        {
          title: this.$t("enseignant.prenom"),
          dataIndex: "employee.firstName",
          key: "firstName",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "firstName",
          },
          onFilter: (value, record) =>
            record.employee.firstName
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("profil.middleName"),
          dataIndex: "employee.middleName",
          key: "middleName",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "middleName",
          },
          onFilter: (value, record) =>
            (record.employee.middleName || "")
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("enseignant.nom"),
          dataIndex: "employee.lastName",
          key: "lastName",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "lastName",
          },
          onFilter: (value, record) =>
            record.employee.lastName
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("enseignant.matiere"),
          dataIndex: "subjects",
          key: "subjects",
          width: 250,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "subject",
          },
          onFilter: (value, record) =>
            record.subjects.some((s) => {
              return s.name.toLowerCase().includes(value.toLowerCase());
            }),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("enseignant.specialite"),
          dataIndex: "speciality",
          key: "speciality",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "speciality",
          },
          onFilter: (value, record) =>
            record.speciality.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("enseignant.grade"),
          dataIndex: "grade",
          key: "grade",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "grade",
          },
          onFilter: (value, record) =>
            record.phone.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("enseignant.mdp"),
          scopedSlots: { customRender: "password" },
          fixed: "right",
        },
        {
          title: this.$t("action.modifier"),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          fixed: "right",
        },
      ];
    },
  },
  async created() {
    this.$on("cancel", () => {
      this.visibleModalPassword = false;
    });
    this.$on("reload", () => {
      this.getTeachers();
      this.visibleModalPassword = false;
    });
    await this.getTeachers();
    // Get positions List
    apiClient
      .post("/positions/filter", { query: { status: "active" } })
      .then((res) => (this.positionsList = res.data))
      .catch(() => {});

    // Get subject List
    apiClient
      .post("/subject/filter", { query: { status: "active" } })
      .then((res) => (this.subjectsList = res.data))
      .catch(() => {});

    apiClient
      .post("/classrooms/filter", {
        query: { status: "active" },
      })
      .then((res) => {
        this.classesData = [...res.data];
      })
      .catch((e) => {
        this.$message.error(this.$t("error.erreur"));
      });

    this.tableLoading = false;
    this.loadingLogins = false;
  },
  data() {
    return {
      qrData: "",
      qrDataImage: "",
      generatedPassword: generatePassword(),
      updateModelKey: 1,
      loadingLogins: true,
      profileDataLoading: false,
      classroomAffectationProfile: [],
      classesData: [],
      positionsList: [],
      subjectsList: [],
      expectedTeachingRows: [],
      dateFormat: "DD/MM/YYYY",
      editingKey: "",
      tableLoading: false,
      visibleParentFile: false,
      data: [],
      filteredData: [],
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      targetKeys: [],
      previewVisible: false,
      previewImage: "",
      form: this.$form.createForm(this),
      updateForm: this.$form.createForm(this),
      kenyanBanks: KENYAN_BANKS,
      updateData: {
        _id: "",
        cin: 0,
        adress: "",
        phone: 0,
        civilStatus: "",
        level: "",
        experiences: "",
        position: { _id: "" },
        contract: "",
        salary: { net: 0 },
        isA_Teacher: false,
        interviewDate: "",
        StartDate: "",
        endDate: "",
        hourlyRate: 0,
        dayOfWeek: 0,
        CNSS: 0,
        RIB: 0,
        PIN: "",
        SHA: "",
        NSSF: "",
        bankAccountNo: "",
        notes: "",
        email: "",
        needValidation: true,
        needNewsValidation: true,
        teacherAddNews: true,
      },
      value: 1,
      value1: 1,
      loadingEnseignant: false,
      visibleData: false,
      visibleUpdateData: false,
      visibleProfileData: false,
      visibleModalPassword: false,
      changePasswordProps: {
        email: "email",
        password: "Mot de passe",
      },
      activeTeacherId: "",
      activeTeacher: {
        employee: { firstName: "", middleName: "", lastName: "" },
      },
      teacherToken: "",
      teacherMfa: { enabled: false, method: null },
      fetchToken: false,
      visibleQrCodeErrorModal: false,
      qrCodeErrorData: [],
    };
  },
  methods: {
    async getTeacherToken() {
      this.fetchToken = true;
      if (this.activeTeacherId) {
        try {
          const { data } = await apiClient.get(
            "/teachers/qrcodeinfo/" + this.activeTeacherId
          );
          this.teacherToken = data.token;
          this.teacherMfa = {
            enabled: !!data.mfa?.enabled,
            method: data.mfa?.method || null,
          };
        } catch (error) {
          this.teacherToken = "";
          this.teacherMfa = { enabled: false, method: null };
        }
      }
      this.fetchToken = false;
    },
    onTeacherMfaDisabled() {
      this.teacherMfa = { enabled: false, method: null };
    },
    async updateToken(token) {
      if (token) {
        this.teacherToken = token;
      } else {
        await this.getTeacherToken();
      }
    },
    updateCredentials(credentials) {
      const teacher = this.data.find(
        (item) => item.key == credentials.idTeacher
      );
      teacher.email = credentials.email;
      this.data = [...this.data];
      this.changePasswordProps.email = credentials.email;
    },
    async getTeachers(status = "active") {
      this.tableLoading = true;
      this.visibleModalPassword = false;
      await apiClient
        .post("/teachers/filter", {
          query: {
            role: "teacher",
            status: status,
          },
        })
        .then((res) => {
          this.data = res.data.map((elem) => ({ ...elem, key: elem._id }));
          this.filteredData = this.data.map((item) => ({ ...item }));
        })
        .catch((e) => {
          this.$message.error(this.$t("error.aucEnseignant"));
        })
        .finally(() => (this.tableLoading = false));
      this.cacheData = this.data.map((item) => ({ ...item }));
    },
    handleTableChange(pagination, filters, sorter, extra) {
      this.filteredData = extra.currentDataSource;
    },
    validateNoWhitespace(rule, value, callback) {
      if (/\s/.test(value)) {
        callback(new Error("Username cannot contain whitespace"));
      } else {
        callback();
      }
    },
    async validateUsernameAvailable(rule, value, callback) {
      try {
        await apiClient.post(`/teachers/checkUsernameAvailable`, {
          email: value,
        });
        callback(); // Username is available, no error
      } catch (error) {
        callback(new Error(this.$t("error.usernameExists"))); // Username is not available
      }
    },
    moment,
    async updatePasswordTrig(e) {
      this.activeTeacherId = e._id;
      this.activeTeacher = e;
      await this.getTeacherToken();
      this.changePasswordProps = {
        email: e.email,
        password: "",
      };

      this.visibleModalPassword = true;
    },
    updateEnseignant(e) {
      e.preventDefault();
      this.updateForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // --- Phone validation for TN/KE ---
          const phone = (values.phone || "").trim();
          if (phone) {
            const digits = phone.replace(/\D/g, "");
            if (phone.startsWith("+216") && digits.length !== 11) {
              this.$message.error(this.$t('requis.telephone'));
              return;
            }
            if (phone.startsWith("+254") && digits.length !== 13) {
              this.$message.error(this.$t('requis.telephoneKE'));
              return;
            }
          }
          // --- End phone validation ---

          this.loadingEnseignant = true;
          values.needValidation = !values.needValidation;
          values.needNewsValidation = !values.needNewsValidation;
          this.applyAttendanceConfigFields(values);
          // Remove empty string fields from the payload
          const cleanedValues = this.removeEmptyStrings(values);
          const id = this.updateData._id;
          apiClient
            .patch(`/teachers/${id}`, { data: cleanedValues })
            .then((res) => {
              this.data = this.data.map((elem) => {
                if (elem._id == id) {
                  elem.subjects = this.subjectsList.filter((sub) =>
                    values.subjects.includes(sub._id)
                  );
                  elem.grade = values.grade;
                  elem.speciality = values.speciality;
                  elem.needValidation = values.needValidation;
                  elem.needNewsValidation = values.needNewsValidation;
                  elem.teacherAddNews = values.teacherAddNews;
                  if (elem.employee) {
                    elem.employee.expectedHoursPerDay = values.expectedHoursPerDay;
                    elem.employee.daysOff = values.daysOff || [];
                    elem.employee.expectedTeachingHoursBySubject =
                      values.expectedTeachingHoursBySubject || [];
                  }
                }
                return elem;
              });
              this.filteredData = this.data.map((item) => ({ ...item }));
              this.$message.success(
                this.$t("success.newsValidationSettingUpdated")
              );
              this.visibleUpdateData = false;
            })
            .catch(() => this.$message.error(this.$t("error.enseignantNonMSA")))
            .finally(() => {
              this.loadingEnseignant = false;
              this.updateForm.resetFields();
            });
        }
      });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(record) {
      this.updateModelKey++;
      this.updateData = record;
      let subs = [];
      record.subjects.forEach((sub) => {
        subs.push(sub._id);
      });
      this.updateData.subs = subs;
      this.syncExpectedTeachingRowsFromEmployee(record.employee);
      this.visibleUpdateData = true;
    },
    profile(record) {
      this.updateData = record;
      this.visibleProfileData = true;
      this.profileDataLoading = true;
      this.classroomAffectationProfile = [];
      apiClient
        .get(`/teachers/classroomAffectations/${record._id}`)
        .then((res) => {
          this.classroomAffectationProfile = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => (this.profileDataLoading = false));
    },
    save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
      this.editingKey = "";
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
        this.filteredData = this.data.map((item) => ({ ...item }));
      }
    },

    removeEmptyStrings(obj) {
      if (obj === null || obj === undefined) {
        return obj;
      }

      if (Array.isArray(obj)) {
        return obj.map(item => this.removeEmptyStrings(item));
      }

      if (moment.isMoment(obj) || obj instanceof Date) {
        return obj;
      }

      if (typeof obj === 'object') {
        const cleaned = {};
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            if (value !== '') {
              const cleanedValue = this.removeEmptyStrings(value);
              if (cleanedValue !== '' &&
                  !(typeof cleanedValue === 'object' && cleanedValue !== null &&
                    Object.keys(cleanedValue).length === 0 && !Array.isArray(cleanedValue))) {
                cleaned[key] = cleanedValue;
              }
            }
          }
        }
        return cleaned;
      }

      return obj;
    },

    addExpectedTeachingRow() {
      this.expectedTeachingRows.push({
        subject: undefined,
        subjectName: "",
        hoursPerWeek: 0,
      });
    },
    removeExpectedTeachingRow(index) {
      this.expectedTeachingRows.splice(index, 1);
    },
    onExpectedSubjectChange(row, subjectId) {
      const subject = this.subjectsList.find((s) => s._id === subjectId);
      row.subject = subjectId || undefined;
      row.subjectName = subject ? subject.name : "";
    },
    syncExpectedTeachingRowsFromEmployee(employee) {
      const rows =
        (employee && employee.expectedTeachingHoursBySubject) || [];
      this.expectedTeachingRows = rows.map((r) => ({
        subject: r.subject ? String(r.subject._id || r.subject) : undefined,
        subjectName: r.subjectName || "",
        hoursPerWeek: Number(r.hoursPerWeek) || 0,
      }));
    },
    applyAttendanceConfigFields(values) {
      values.expectedTeachingHoursBySubject = (this.expectedTeachingRows || [])
        .filter((r) => r.subject && Number(r.hoursPerWeek) > 0)
        .map((r) => ({
          subject: r.subject,
          subjectName: r.subjectName || "",
          hoursPerWeek: Number(r.hoursPerWeek) || 0,
        }));
      if (
        values.expectedHoursPerDay === "" ||
        values.expectedHoursPerDay === undefined
      ) {
        values.expectedHoursPerDay = null;
      } else if (values.expectedHoursPerDay != null) {
        values.expectedHoursPerDay = Number(values.expectedHoursPerDay);
      }
      if (!Array.isArray(values.daysOff)) values.daysOff = [];
      return values;
    },
    addEnseignant(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(async (err, values) => {
        values.isA_Teacher = true;
        if (!err) {
          // --- Phone validation for TN/KE ---
          const phone = (values.phone || "").trim();
          if (phone) {
            const digits = phone.replace(/\D/g, "");
            if (phone.startsWith("+216") && digits.length !== 11) {
              this.$message.error(this.$t('requis.telephone'));
              return;
            }
            if (phone.startsWith("+254") && digits.length !== 13) {
              this.$message.error(this.$t('requis.telephoneKE'));
              return;
            }
          }
          // --- End phone validation ---

          // Ensure bankName and bankBranch are explicitly set to empty string if undefined (not selected)
          if (this.isKenyan) {
            if (values.bankName === undefined || values.bankName === null) {
              values.bankName = '';
            }
            if (values.bankBranch === undefined || values.bankBranch === null) {
              values.bankBranch = '';
            }
          }
          const classrooms = values.classrooms;
          delete values.classrooms;
          // Preserve bankName and bankBranch empty strings before cleaning
          const bankNameValue = values.bankName;
          const bankBranchValue = values.bankBranch;
          this.applyAttendanceConfigFields(values);
          const cleanedValues = this.removeEmptyStrings(values);
          TEACHER_DATE_FIELDS.forEach((field) => {
            if (cleanedValues[field] === null) delete cleanedValues[field];
          });
          if (cleanedValues.needNewsValidation !== undefined) {
            cleanedValues.needNewsValidation = cleanedValues.needNewsValidation === "true" || cleanedValues.needNewsValidation === true;
          }
          if (cleanedValues.teacherAddNews !== undefined) {
            cleanedValues.teacherAddNews = cleanedValues.teacherAddNews === "true" || cleanedValues.teacherAddNews === true;
          }
          // Restore bankName and bankBranch if they were empty strings
          if (this.isKenyan) {
            if (bankNameValue === '') {
              cleanedValues.bankName = '';
            }
            if (bankBranchValue === '') {
              cleanedValues.bankBranch = '';
            }
          }
          this.loadingEnseignant = true;
          let teacherId = "";
          await apiClient
            .put("/teachers", cleanedValues)
            .then((res) => {
              teacherId = res.data._id;
              this.data.push({ ...res.data, key: res.data._id });
              this.filteredData = this.data.map((item) => ({ ...item }));
              apiClient
                .post("/teachers/affectationClassrooms/" + res.data._id, {
                  classrooms,
                })
                .then(async (res) => {
                  this.$message.success(this.$t("success.enseignantAjout"));
                  this.handleCancel();
                })
                .catch((e) => {
                  this.$message.error(
                    e?.response?.data?.errorCode
                      ? this.$t(`errorCode.${e.response.data.errorCode}`)
                      : this.$t("error.enseignantNonAjoute")
                  );
                });
            })
            .catch((e) => {
              const field =
                TEACHER_ERROR_FIELDS[e?.response?.data?.errorCode];
              if (field) {
                this.form.setFields({
                  [field]: {
                    value: this.form.getFieldValue(field),
                    errors: [
                      new Error(
                        this.$t(`errorCode.${e.response.data.errorCode}`)
                      ),
                    ],
                  },
                });
              }
              showApiError(this, e);
            })
            .finally(() => (this.loadingEnseignant = false));
        }
      });
    },
    getQrImage(dataUrl) {
      this.qrDataImage = dataUrl;
    },
    handleCancelPwd() {
      this.visibleModalPassword = false;
    },
    handleCancel(e = null) {
      this.form.resetFields();
      this.updateForm.resetFields();
      this.expectedTeachingRows = [];
      this.visibleData = false;
      this.visibleUpdateData = false;
      this.visibleProfileData = false;
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },

    generatePdf() {
      this.$gtag.event("Imp tableau teachers", {
        event_category: "Impression PDF",
        event_label: "Personnel - ListeEnseignants section",
        value: 1,
      });

      const isArabic = this.$i18n.locale === 'ar-AR';

      // Helper function to reverse array if Arabic
      const reverseIfArabic = (arr) => isArabic ? arr.slice().reverse() : arr;


      const doc = pdfHeader(this.settings, {
        title: this.$t("menu.listeEnseignants"),
        locale: this.$i18n.locale
      });
      var arr = [];
      const array = [];
      var counter = 1;
      let somme = 0;

      for (let i = 0; i < this.filteredData.length; i++) {
        arr.push(counter);
        // arr.push(this.data[i].matricule);
        arr.push(
          this.filteredData[i].employee.firstName +
            (this.filteredData[i].employee.middleName
              ? " " + this.filteredData[i].employee.middleName
              : "") +
            " " +
            this.filteredData[i].employee.lastName
        );
        let sub = "";
        for (let j = 0; j < this.filteredData[i].subjects.length; j++) {
          sub = sub + this.filteredData[i].subjects[j].name + "\n";
        }
        arr.push(sub);
        arr.push(this.filteredData[i].speciality);
        arr.push(this.filteredData[i].grade);

        // Reverse for Arabic if needed
        if (isArabic) {
          arr.reverse();
        }

        array.push(arr);
        arr = [];
        counter++;
      }
      doc.autoTable({
        theme: "grid",
        styles: { font: "Amiri", halign: isArabic ? "right" : "left" },
        headStyles: { halign: isArabic ? "right" : "left" },
        bodyStyles: { halign: isArabic ? "right" : "left" },
        startY: 45,
        head: [
          reverseIfArabic([
            this.$t("paiement.num"),
            this.$t("inscription.nom"),
            this.$t("enseignant.matiere"),
            this.$t("enseignant.specialite"),
            this.$t("enseignant.niveau"),
          ])
        ],
        body: array,
        foot: [],
      });

      doc.save(this.$t("enseignant.listeEnseignantsPDF") + ".pdf");
    },

    async generatePdfLogins() {
      try {
        this.loadingLogins = true;
        const response = await apiClient.get("/teachers/all-qrcodeinfo/all");
        const teacherList = response.data;
        if (teacherList.length === 0) {
          this.$message.error(this.$t("error.aucEnseignant"));
          throw new Error(this.$t("error.aucEnseignant"));
        }

        const result = await generateAllLoginPdf({
          parentsLogins: teacherList,
          settings: this.settings,
          userType: "teacher",
          t: this.$t.bind(this),
          locale: this.$i18n.locale,
        });

        if (result.qrCodeErrors && result.qrCodeErrors.length > 0) {
          this.qrCodeErrorData = result.qrCodeErrors.map((user) => ({
            fullName: `${user.firstName}${
              user.middleName ? " " + user.middleName : ""
            } ${user.lastName}`,
            _id: user._id,
          }));
          this.visibleQrCodeErrorModal = true;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingLogins = false;
      }
    },
    showModal() {
      this.expectedTeachingRows = [];
      this.visibleData = true;
      this.generatedPassword = generatePassword();
    },
    onChange(checked) {
      this.getTeachers(checked == true ? "active" : "inactive");
    },
    onChangeParent(e) {},
    handleCancelImage() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChangeSelect(value) {},
    handleBlur() {},
    handleFocus() {},
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    generatePassword,
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return getFieldError("password");
    },
    validateStrongPassword(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("requis.mdp")));
      } else if (value == this.form.getFieldValue("email")) {
        callback(
          new Error(this.$t("profil.passwordMustNotMatchUsername"))
        );
      } else if (!/[A-Z]/.test(value)) {
        callback(
          new Error(this.$t("profil.passwordMustIncludeUppercase"))
        );
      } else if (!/[a-z]/.test(value)) {
        callback(
          new Error(this.$t("profil.passwordMustIncludeLowercase"))
        );
      } else if (!/[0-9]/.test(value)) {
        callback(
          new Error(this.$t("profil.passwordMustIncludeDigit"))
        );
      } else if (value.length < 8) {
        callback(
          new Error(this.$t("profil.passwordMinLength"))
        );
      } else {
        callback();
      }
    },
  },
};
</script>
<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.editable-row-operations a {
  margin-right: 8px;
}

.switch {
  float: right;
  margin-right: 15px;
}

.bottom {
  margin-top: 7px;
}

label {
  width: 300px;
  line-height: 26px;
  margin-bottom: 20px;
}

a-input {
  height: 25px;
  width: 50%;
  margin-left: 50px;
}

.span {
  /* display: flex;  */
  flex-direction: row;
}

.space {
  margin-left: 200px;
}

.inp {
  margin-left: 0px;
}

.clearfix {
  float: right;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.card >>> .ant-table-tbody tr {
  cursor: pointer !important;
}

.subject-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  position: relative;
}

.more-subjects {
  position: relative;
  cursor: pointer;
}

.remaining-subjects {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-top: 4px;
  white-space: nowrap;
  z-index: 1000;
}

.more-subjects:hover .remaining-subjects {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

/* Add styles to ensure table rows don't interfere with dropdown */
.card >>> .ant-table-tbody > tr {
  position: relative;
}

.card >>> .ant-table-tbody > tr:hover {
  z-index: 1;
}

.card >>> .ant-table-tbody > tr:hover .remaining-subjects {
  z-index: 1001;
}

/* Update modal */
.teacher-update-form {
  padding: 4px 0 8px;
}

.teacher-update-form .update-fieldset {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 16px 20px;
  margin-bottom: 20px;
  background: #fafafa;
}

.teacher-update-form .update-fieldset--validation {
  background: #f5f9ff;
  border-color: #d6e4ff;
}

.teacher-update-form .update-legend {
  font-weight: 600;
  font-size: 13px;
  color: #262626;
  padding: 0 8px;
  margin-bottom: 0;
  width: auto;
  border: none;
}

.teacher-update-form .validation-toggles {
  display: flex;
  align-items: stretch;
}

.teacher-update-form .validation-toggles > [class*="col-"] {
  display: flex;
}

.teacher-update-form .validation-form-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;
}

.teacher-update-form .validation-form-item .ant-form-item-label {
  flex: 1;
}

.teacher-update-form .validation-form-item .ant-form-item-label label {
  white-space: normal;
  line-height: 1.4;
}

.teacher-update-form .validation-form-item .ant-form-item-control-wrapper {
  flex: none;
}

.update-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 8px;
  margin-top: 4px;
  border-top: 1px solid #f0f0f0;
}
</style>
